import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

type WalletsTableSkeletonProps = {}

export const WalletsTableSkeleton: React.FC<WalletsTableSkeletonProps> = () => (
  <Root>
    <Skeleton height={16} width={16} />
    <Shifted>
      <Skeleton height={14} width={100} />
    </Shifted>
    <Skeleton height={14} width={100} />
    <Skeleton height={14} width={120} />
    <Skeleton height={14} width={120} />
    <Skeleton height={22} width={80} />
    <Skeleton height={40} width={120} />
  </Root>
)

const Root = styled.div`
  border-radius: 10px;

  &:nth-child(odd) {
    background: var(--appearanceA-4, var(--appearanceA-4));
  }
  display: grid;
  grid-auto-flow: column;
  width: 100%;

  height: 50px;
  align-items: center;
  padding-inline: 12px;
  justify-content: start;

  grid-template-columns:
    32px minmax(100px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr)
    minmax(120px, 1fr) minmax(120px, 1fr) 116px 60px;
`

const Shifted = styled.div`
  padding-inline-start: 10px;
`
